import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/observable/empty';
import { BranchModel, UserModel } from '../model/index';

import * as $ from 'jquery';
@Injectable()
export class SmsService {
    private headers = new Headers({
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

        //'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8', 'Accept': 'q=0.8;application/json;q=0.9'
    });
    private smsUrl = 'api/sms';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    saveSms(userData: any): Promise<UserModel> {
        const url = `${this.smsUrl}/saveSms`;

        return this.http
            .post(url, $.param(userData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as UserModel)
            .catch(this.handleError);
    }

    getSmsList(userData: any): Promise<UserModel> {
        const url = `${this.smsUrl}/getSmsList`;

        return this.http
            .post(url, $.param(userData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as UserModel)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/sms.service.ts